import cn from 'classnames/bind'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FileEarmarkPdf } from '../../../components/svg/FileEarmarkPdf'
import { useGetPrintableOrderQuery } from '../../../services/peppol'
import { useAppDispatch } from '../../../store'
import { addAlert } from '../../../store/alerts'
import styles from './index.module.css'

const cx = cn.bind(styles)

type Props = {
  orderUuid: string
}

export const DownloadOrderPdf = ({ orderUuid }: Props) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const ref = useRef<HTMLAnchorElement>(null)
  const [downloading, setDownloading] = useState(false)

  const { current } = ref

  const { data, error } = useGetPrintableOrderQuery(
    { uuid: orderUuid, fileType: 'application/pdf' },
    { skip: !downloading },
  )

  useEffect(() => {
    if (error !== undefined) {
      setDownloading(false)
      dispatch(addAlert({ type: 'error', translationId: 'feedback.error.generic' }))
    }
  }, [dispatch, error, t])

  useEffect(() => {
    if (data !== undefined && current !== null) {
      setDownloading(false)
      current.href = data.url
      current.click()
    }
  }, [current, data])

  const startDownload = () => {
    setDownloading(true)
  }

  return (
    <>
      <a ref={ref} className={cx('hidden-trigger')} href="#/">
        {t('pages.incomingOrders.downloadOrderPdf')}
      </a>

      <button
        className={cx('cta')}
        title={t('pages.incomingOrders.downloadOrderPdf')}
        onClick={startDownload}
      >
        <FileEarmarkPdf width={20} height={20} />
      </button>
    </>
  )
}
